<template>
  <div> 
      <ul-nav  v-if="this.batch_id != null" :batch_id="batch_id"/>
    <div class="container-fluid" style="height: 800px">
     <div class="row">
        <h2 class="table-name" style="margin-bottom: 0">Editing {{ readableName(table) }} Table</h2>
        <span v-if="canAdd && !['district_boundaries', 'files', 'ultralocal.ul_file_uploads','officeholder_photos_staging', 'tiktok_people_photos', 'fetch_services.response_election_dates'].includes(table) " class="edit-add"><router-link :to="`/add/${table}`"><i>(Switch to add page)</i></router-link></span>

        <br />
        <div v-if="this.$route.params.table === 'survey_questions'" style="color: red; text-align: center">
          <p><b>WARNING:</b> These questions are part of Ballotpedia's Candidate Connection surveys and
          should rarely be edited. Confirm with the Tech and Elections teams before making changes.</p>
          <br />
        </div>
        <div v-if="this.$route.params.table === 'local_candidate_research_worksheet'" style="text-align: center">
          <p>This table includes local candidates up for election, regardless of incumbency status.</p>
        </div>
        <div class="btn-group text-center" style="margin-top: 10px; margin-bottom: 10px;">
          <button class="btn btn-primary btn-hide" style="width: 150px" v-if="!showSearch" v-on:click="toggleSearch">
            <i class="fa fa-search" style="font-size: 16px"></i>
              Search
              <span v-if="activeQuery && !searchError" class="badge">Active</span>
              <span v-if="activeQuery && searchError" class="badge badge-error">Error</span>
          </button>
          <button class="btn btn-primary btn-hide" style="width: 150px" :style="visibility" v-if="!showSearch && canDelete" @click="submitDeletes">
            <i class="fa fa-trash" style="font-size: 16px"></i> Delete selected
          </button>
          <button class="btn btn-primary btn-hide" style="width: 150px" :style="visibility" v-if="!showSearch && (canUpdate || canDelete)" @click="toggleLog">
            <i class="fa fa-edit" style="font-size: 16px"></i> {{toggleEditHistory ? 'Hide Log' : 'Show Log'}}
          </button>
          <button class="btn btn-primary btn-hide" style="width: 175px" :style="visibility" v-if="!showSearch" @click="resetColumnOrder">
            <i class="fa fa-undo" style="font-size: 16px"></i> Reset Column Order
          </button>
          <button class="btn btn-primary btn-hide" style="width: 175px" :style="visibility" v-if="!showSearch && table === 'people'">
            <a :href="`/add/people_photos`" target='_blank' style="color: inherit"><i class="fa fa-link" style="font-size: 16px"></i> People Photos Table</a>
          </button>
          <button class="btn btn-default btn-hide" style="width: 80px" v-if="showSearch" v-on:click="toggleSearch">
            Hide
          </button>
          <button title="Promote selected contests to gold" class="btn btn-primary btn-hide" style="width: 150px" :style="visibility" v-if="!showSearch && this.$route.params.table === 'ultralocal.ul_bfed_promote_to_gold_workflow' && this.batch_id > 0"  @click="promoteToGold('selected')">
            <i class="fa" style="font-size: 16px"></i> Promote Selected
          </button>
          <button title="Promote all contests in the batch that are valid for promotion" class="btn btn-primary btn-hide" style="width: 150px" :style="visibility" v-if="!showSearch && this.$route.params.table === 'ultralocal.ul_bfed_promote_to_gold_workflow' && this.batch_id > 0"  @click="promoteToGold('all')">
            <i class="fa" style="font-size: 16px"></i> Promote All
          </button>
           <a v-if = "domain == 'prod'" :href="'https://metabase.ballotpedia.org/question/4183?batch_id='+ batch_id" target='_blank'> 
            <button title="Link to a metabase query that will show what will be promoted if 'Promote All' is selected" class="btn btn-primary btn-hide"  :style="visibility" v-if="!showSearch && this.$route.params.table === 'ultralocal.ul_bfed_promote_to_gold_workflow' && this.batch_id > 0">What will be promoted</button></a>
           <a v-else  :href="'https://metabase.ballotpedia.org/question/4026?batch_id='+ batch_id" target='_blank'>
                <button title="Link to a metabase query that will show what will be promoted if 'Promote All' is selected" class="btn btn-primary btn-hide"  :style="visibility" v-if="!showSearch && this.$route.params.table === 'ultralocal.ul_bfed_promote_to_gold_workflow' && this.batch_id > 0">What will be promoted</button>
           </a>
          <a v-if = "domain == 'prod'" :href="'https://metabase.ballotpedia.org/question/4345?batch='+ batch_id" target='_blank'> 
            <button title="Link to a metabase query that will show links to errors that need to be fixed." class="btn btn-primary btn-hide"  :style="visibility" v-if="!showSearch && (this.$route.params.table === 'ultralocal.ul_bfed_candidates' || this.$route.params.table === 'ultralocal.ul_bfed_contests') && this.batch_id > 0">Fix these errors</button></a>
           <a v-else  :href="'https://metabase.ballotpedia.org/question/4346?batch='+ batch_id" target='_blank'>
                <button title="Link to a metabase query that will show links to errors that need to be fixed." class="btn btn-primary btn-hide"  :style="visibility" v-if="!showSearch && (this.$route.params.table === 'ultralocal.ul_bfed_candidates' || this.$route.params.table === 'ultralocal.ul_bfed_contests') && this.batch_id > 0">Fix these errors</button>
           </a>
          <button title="Create selected pages" class="btn btn-primary btn-hide" style="width: 150px" :style="visibility" v-if="!showSearch && this.$route.params.table === 'ultralocal.ul_bfed_page_creation_workflow'"  @click="createPages('selected')">
            <i class="fa" style="font-size: 16px"></i> Create Selected
          </button>
          <button title="Create all pages" class="btn btn-primary btn-hide" style="width: 150px" :style="visibility" v-if="!showSearch && this.$route.params.table === 'ultralocal.ul_bfed_page_creation_workflow'"  @click="createPages('all')">
            <i class="fa" style="font-size: 16px"></i> Create All
          </button>
       </div>

        <div v-if="showSearch">
          <div class="checkbox">
            <label>
              <input type="checkbox" v-on:change="depthLevel" />
              Complex Search
            </label>
          </div>
          <div class="checkbox">
            <label>
              <input type="checkbox" v-model="isCountOnly" v-on:click="toggleCountOnly" />
              Count Only
            </label>
          </div>
          <vue-query-builder :rules="rules" :maxDepth="depth" :labels="labels" :styled="true" v-model="query"></vue-query-builder>

          <div style="display: block; margin-top: 20px">
            <div class="btn-group text-center">
              <button class="btn btn-default btn-hide btn-share" v-on:click="doFormatUrl">
                Share Url
              </button>
              <button class="btn btn-primary btn-hide btn-search" v-on:click="doSearch">
                Search
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <hr />
        </div>

        <div v-if="!searchError" class="search-options">

          <div style="display: inline">
            <label for="pageSelect" style=" margin-bottom: 15px">Records per page</label>
            <select class="form-control record-number" :value="limit" id="pageSelect" v-on:change="changeLimit">
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
              <option>500</option>
            </select>
          </div>

          <div style="display: inline">
            <label for="pageNum" style=" display: inline;">Page Number</label>
            <input type="number" :value="offset" min="1" v-on:change="changePage" class="form-control page-select" placeholder="Page #" id="pageNum" />
          </div>

          <div style="display: inline">
            <label for="orderBy" style=" margin-bottom: 15px">Sort Column</label>
            <select v-on:change="setOrderBy" v-model="orderBy" class="form-control orderBy" id="orderBy">
              <option v-for="col in orderByFilters" :key="col.value" :value="col.value">{{ col.label }}</option>
            </select>
          </div>

          <div style="display: inline">
            <label for="sortDirection" style=" margin-bottom: 15px">Sort Direction</label>
            <select v-on:change="setSortDirection" v-model="sortDirection" class="form-control sortBy" id="sortDirection">
              <option :value="''">None</option>
              <option :value="'desc'">Descending</option>
              <option :value="'asc'">Ascending</option>
            </select>
          </div>

          <div style="display: inline">
            <label for="frozenColumns" style=" margin-bottom: 15px">Frozen Columns</label>
            <select v-on:change="setFrozenColumns" v-model="leftColsFixed" class="form-control frozenSelect" id="frozenColumns">
              <option :value="0">0</option>
              <option :value="1">1</option>
              <option :value="2">2</option>
              <option :value="3">3</option>
              <option :value="4">4</option>
              <option :value="5">5</option>
              <option :value="6">6</option>
              <option :value="7">7</option>
              <option :value="8">8</option>
            </select>
          </div>

          <div v-if="workflowOptions.length > 0" style="display: inline">
            <label :for="`${table}_workflow`" style="margin-bottom: 15px">Workflow</label>
            <select v-on:change="setWorkflow" v-model="workflow" class="form-control sortBy workflow" :id="`${table}_workflow`">
              <option :value="''">All</option>
              <option
                v-for="wf in workflowOptions"
                :key="wf.workflow_name"
                :value="wf.workflow_name"
              >{{ wf.workflow_name }}</option>
            </select>
          </div>
        </div>
        </div>

        <div v-if="loading" class="fa-3x text-center">
          <i class="fas fa-spinner fa-spin"></i>
        </div>

        <br />
        <div v-if="searchError">
          <p>There is an error in your search criteria.</p>
          <p>This can occur for example if you attempt to search an ID field with text that is supposed to be numeric.</p>
          <p>Please check the search and try again.</p>
        </div>

        <div v-if="assignmentError" class="badge badge-error">
          <p>Error making assignments - please refresh page.</p>
          <p>If further errors occur, notify Ballotpedia.</p>
        </div>

        <div v-if="countReturned">
          <p>Number of records matching the search criteria: {{this.countReturned}}</p>
        </div>

          <HandsOnTable :hotdata="hotdata" :table="table" :columns="columnMetaData" :getFilteredData="getFilteredData" :toggleEditHistory="toggleEditHistory" ref="hot"  @columns-moved="handleColumnsMoved"></HandsOnTable>
    </div>
  </div>
</template>

<script>
import HandsOnTable from "../components/HandsOnTable.vue";
import VueQueryBuilder from "vue-query-builder";
//import validator from "../../node_modules/@bp_api4/schema_validation/index.js";
import getColumnMetaData from '../mixins/columnMetaData.js';
import { deleteMixin } from "../mixins/crud.js";
import getFiltersForSearch from '../mixins/filtersForSearch.js';
import getOrderByFilters from '../mixins/getOrderByFilters.js';
import getTablePermissions from '../mixins/getTablePermissions.js';
import readableName from '../mixins/readableName';
import ULNavHeader from "../components/shared/ULNavHeader";
import hideColumnsMixin from '../mixins/hideColumns.js';

export default {
  name: "Tables",

  components: {
    HandsOnTable,
    VueQueryBuilder,
    "ul-nav": ULNavHeader
  },
  mixins: [deleteMixin, getColumnMetaData, getFiltersForSearch, getOrderByFilters, getTablePermissions, readableName, hideColumnsMixin],

  methods: {
    async handleColumnsMoved() {
      // we need to recalculate the columnMetaData when a column is moved or the new positions do not remain if the page is sorted or paged.
      // we update the columnMoved indicator.  If a search, sort, page, or limit request is issued and this columnMoved is true we sort the ColumnMetatData.
      this.columnMoved = true;
    },


    sortColumnMeta() { 
      let sorted = JSON.parse(localStorage.getItem(this.table));
      this.columnMetaData.sort((a, b) => {
          const indexA = sorted.indexOf(a.title);
          const indexB = sorted.indexOf(b.title);
          return indexA - indexB; // Ascending order
       })   
       this.$refs.hot.$refs.hot.hotInstance.updateSettings({
         columns: this.columnMetaData
       })
    },


    toggleLog() {
      this.toggleEditHistory = !this.toggleEditHistory;
    },


    doSearch() {
      this.showSearch = false; // Hide search after click
      if (this.columnMoved == true){
        this.sortColumnMeta();
        this.columnMoved = false;
      }
      this.getFilteredData();
    },


    changeLimit() {
      this.limit = event.target.value;
      if (this.columnMoved == true){
        this.sortColumnMeta();
        this.columnMoved = false;
      }
      this.getFilteredData();
     },


    changePage() {
      this.offset = event.target.value;
      if (this.columnMoved == true){
        this.sortColumnMeta();
        this.columnMoved = false;
      }
      this.getFilteredData();
    },


    setOrderBy() {
      this.orderBy = event.target.value;
      if (this.columnMoved == true){
        this.sortColumnMeta();
        this.columnMoved = false;
      }
      this.getFilteredData();
    },


    setSortDirection() {
      this.sortDirection = event.target.value;
      if (this.columnMoved == true){
        this.sortColumnMeta();
        this.columnMoved = false;
      }
      this.getFilteredData();
    },


    setFrozenColumns() {
      this.leftColsFixed = event.target.value; // Need to set this for v-model

      this.$refs.hot.$refs.hot.hotInstance.updateSettings({
        fixedColumnsLeft: event.target.value
      });
      localStorage.setItem(`${this.table}-save-frozen-cols`, JSON.stringify(event.target.value));
    },


    hideColumnsForWorkflow() {
      const thisHot = this.$refs.hot.$refs.hot.hotInstance;
      const selectedWorkflow = this.workflowOptions.find(wf => wf.workflow_name === this.workflow);
      const hiddenColsIndexes = selectedWorkflow
        ? this.hiddenColumnIndexesForWorkflow(selectedWorkflow.columns)
        : this.hiddenColumns;

      thisHot.updateSettings({
        hiddenColumns: { columns: hiddenColsIndexes },
      });
    },


    setWorkflow() {
      let value_str = this.workflow;

      if (this.workflowOptions.length > 0) {
        this.hideColumnsForWorkflow();
      } else if ( value_str ) {
        let hidden_cols = value_str.split(',');
        let hidden_cols_int_array = hidden_cols.map(function (x) {
          return parseInt(x, 10);
        });
        this.$refs.hot.$refs.hot.hotInstance.updateSettings({
          hiddenColumns: {columns: hidden_cols_int_array}
        });
      } else {
        this.$refs.hot.$refs.hot.hotInstance.updateSettings({
          hiddenColumns: this.hiddenColumns
        });
      }
      if (this.$route.params.table === 'vote_in_person' && !(value_str)) {
        this.$refs.hot.$refs.hot.hotInstance.render()
      }
    },


    toggleSearch() {
      this.showSearch = !this.showSearch;
    },


    resetColumnOrder() {
      localStorage.removeItem(this.table);
      this.$router.go()
    },


    async runUltralocalQA(){
      /* this method calls api4 to start the ultralocal qa ecs task.
        if we are running on local host it will call the qa task that runs in dummy
        if we are not running on localhost it will call the prod qa task
        when the new prod qa task goes into effect, all that needs to be done here is to remove the comments on the container overrides after the else.
      */
      let container_overrides;
      let task_definition;
      if (process.env.VUE_APP_API4_DOMAIN === 'http://localhost:3000' || process.env.VUE_APP_API4_DOMAIN == "https://dev-api4.ballotpedia.org") {
        container_overrides =  {
          "name": "qa-app",
          "command": ['python', 'app.py', '--ultralocal', '--dummy']
       }
          task_definition = 'api4-qa-app-dev'
      } else {
      //   container_overrides = 
      //  {
      //     "name": "qa-app",
      //     "command": ['python', 'app.py', '--ultralocal']
      //  }
         task_definition = 'api4-qa-app'
      }
     
      let params = {
        cluster_name: 'default',
        task_definition: task_definition,
        launch_type: 'FARGATE'
        //,
        //ul_batch: batch_id
      } 
      if (container_overrides) {  // Check if `someVariable` has data (truthy value)
          params.containerOverrides = container_overrides;  // Add the new_param to params
      }
      
      //response = await response.json(); // Convert response to JSON
      let response = await this.startEcsTask(params)
      if (response.success === true ) {
          alert('The QA process has been started. Check the batch summary page for completion time.');
      } else {
        alert('There was an issue starting the QA process.  Please try again or contact a member of the tech team.')
      }
    
    },


    depthLevel() {
      this.depth = this.depth === 3 ? 1 : 3;
    },


    toggleCountOnly() {
      this.isCountOnly = !this.isCountOnly;
    },


    doFormatUrl() {
      const query = {};
      query.where = this.query;
      query.table = this.table;
      query.limit = this.limit;
      query.offset = this.offset;
      query.orderBy = this.orderBy ? `${this.orderBy} ${this.sortDirection}` : null;
      query.workflow = this.workflow ? this.workflow : null;

      let filterUrl;
      if (this.query === null && !this.orderBy) {
        filterUrl = `${window.location.href.split("?")[0]}`;
      } else {
        filterUrl = `${window.location.href.split("?")[0]}?${encodeURIComponent(JSON.stringify(query))}`;
      }

      let textArea = document.createElement("textarea");
      textArea.value = filterUrl;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        window.alert("Sharable URL copied to clipboard");
      } catch (err) {
        //empty
      }
      document.body.removeChild(textArea);
    },


    async startEcsTask(params){
      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/run_tasks/run_ecs_task`;

      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
        method: "POST",
        headers: headers,
        credentials: 'include',
        body: JSON.stringify(params)
      });

      response = await response.json(); // Convert response to JSON
      return response;
    },


    hideColumns() {
      const roles = localStorage.getItem('roles') || '';

      if (this.table === 'local_candidate_research_worksheet') {
        // volunteers should only see columns related to candidate email and candidate website
        // also removes the same columns from the search dropdown menu
        if (roles.includes('volunteer_local_candidate_researcher')) {
          this.hiddenColumns = {
            columns: this.hiddenColumnIndexesForNames([
              'ID', 'Personal Facebook URL', 'Candidate Facebook URL', 'Personal Instagram Url',
              'Candidate Instagram URL', 'Personal Twitter Handle', 'Candidate Twitter Handle',
              'Personal YouTube Url', 'Candidate YouTube Url', 'Personal TikTok Url', 'Candidate TikTok Url',
              'Personal LinkedIn Url', 'Personal Email', 'Candidate Website Issues Subpage Url',
              'Personal Threads URL', 'Candidate Threads URL', 'Personal WhatsApp Channel',
              'Candidate WhatsApp Channel', 'Personal WhatsApp Number', 'Candidate WhatsApp Number',
              'Date Last Audited', 'Person ID'
            ])
          };
        } else if (roles.includes('local_candidate_researcher')) {
          this.hiddenColumns = {
            columns: this.hiddenColumnIndexesForNames([
              'Personal Facebook URL', 'Personal Instagram Url', 'Candidate Instagram URL',
              'Personal Twitter Handle', 'Candidate Twitter Handle', 'Personal YouTube Url',
              'Candidate YouTube Url', 'Personal TikTok Url', 'Candidate TikTok Url',
              'Personal Threads URL', 'Candidate Threads URL', 'Personal WhatsApp Channel',
              'Candidate WhatsApp Channel', 'Personal WhatsApp Number', 'Candidate WhatsApp Number'
            ])
          };
        }

        if (this.hiddenColumns.columns) {
          this.rules = this.rules.filter((rule, i) => {
            return !this.hiddenColumns.columns.includes(i);
          });
        }
      } else if (this.table === 'ultralocal.ul_bfed_contacts') {
        if (roles.includes('ul_bfed_candidate_researcher')) {
          this.hiddenColumns = {
            columns: this.hiddenColumnIndexesForNames([
              'Date Last Audited', 'BFED Contest ID', 'BFED Candidate ID', 'Assigned to', 'Updated'
            ])
          };
        }
      } else if (this.table === 'school_board_research_worksheet') {
        if (roles.includes('school_research_contractor')) {
          this.hiddenColumns = {
            columns: this.hiddenColumnIndexesForNames(['ID', 'Office ID', 'Person ID', 'Officeholder ID'])
          };
        }
      } else if (this.table === 'school_district_research') {
        if (roles.includes('school_research_contractor')) {
          this.hiddenColumns = {
            columns: this.hiddenColumnIndexesForNames(['ID'])
          };
        }
      } else if (this.table === 'greenhouse_page_creation') {
        this.hiddenColumns = {
          columns: this.hiddenColumnIndexesForNames(['Candidate'])
        };
      } else if (this.table === 'ultralocal.ul_bfed_promote_to_gold_workflow'  &&  this.batch_id < 1) {
        // Special case where we actually want to hide a specially-named "Select" column.
        // This column does not exist in column_descriptions, so we are going to leave the hiding based on the index.
        this.hiddenColumns = {
          columns: [7]
        }
      } else if (this.table === 'ultralocal.ul_bfed_page_creation_workflow'  &&  this.batch_id < 1) {
        // Special case where we actually want to hide a specially-named "Select" column.
        // This column does not exist in column_descriptions, so we are going to leave the hiding based on the index.
        this.hiddenColumns = {
          columns: [13]
        }
      }
    },


    async getFilteredData() {
      this.loading = true;
      let query = {};
      query.where = this.query;
      query.table = this.table;
      query.limit = this.limit;
      query.offset = this.offset;
      query.orderBy = this.orderBy ? `${this.orderBy} ${this.sortDirection}` : null;
      query.isCountOnly = this.isCountOnly;

      if (query.where && query.where.children) {
        this.activeQuery = true;
        // If user removes search criteria, null the WHERE clause.
        if (query.where.children.length === 0) {
          query.where = null;
          this.activeQuery = false;
        }
      }

      if (this.batch_id != null) {
        if (query.where === null)
        {
          query.where = {logicalOperator: "all",
            children: []
          }
        }
        if (query.where.children &&   (query.where.children).some(item => item.query.rule === 'named_bfed_batch')) {
            //empty
        } else {
         query.where.children.push(
              // Build the query like the queryBuilder does it to pass to backend.
              {
                type: "query-builder-rule",
                query: {
                  rule: "named_bfed_batch",
                  selectedOperator: 'equal',
                  selectedOperand: "named_bfed_batch",
                  value: this.batch_id
                }
              }
            );
        }
      }

      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/filteredData`;

      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
        method: "POST",
        headers: headers,
        credentials: 'include',
        body: JSON.stringify(query)
      });
       
      if ( response.status == 403 ) {
        response = await response.json();
        alert(response.message);
        window.location.href = '/login';
      } else {
        response = await response.json(); // Convert response to JSON
        if (response.success === true) {
        
          this.hotdata = []; // Clear current table data.
          await response.data.forEach(item => {
            item["columnselected"] = false;
           
            item["promoteselected"] = '';
            this.hotdata.push(item);
          });
          this.searchError = false;
          this.$refs.hot.$refs.hot.hotInstance.loadData(this.hotdata);

          // Check if just getting count of records:
          if (response.data && response.data[0] && response.data[0].count) {
            this.countReturned = response.data[0].count;
          } else {
              this.countReturned = false;
          }

        } else if (response.success === false ) {
          this.searchError = true;
          this.hotdata = [];
        }
        this.setWorkflow();
        this.loading = false;
        // When the table is reloaded, we need to re-apply the settings for fixed columns:
        this.$refs.hot.$refs.hot.hotInstance.updateSettings({
          fixedColumnsLeft: this.leftColsFixed 
        });
      }
    },


    async createPages(allOrSome) {
      let ids = new Set();
      if (allOrSome == 'selected') {
        this.$refs.hot.$refs.hot.hotInstance.getSourceData().forEach(item => {
          if (item.promoteselected === true && item.id) {
            ids.add (item.id)  
          }
        });
      } else if (allOrSome == 'all') {
        ids.add('all')
      }
      let idsString = [...ids].join(", ");
      if (ids.size > 0) {
        const container_overrides = {
          "name": 'import-engine-service-page-creation' ,
          "environment": [
            {
              "name": "contests",
              "value": idsString
            },
            {
              "name": "batch",
              "value": this.batch_id
            }
          ]
        }
                  
        let params = {
          cluster_name: 'default',
          task_definition: (process.env.VUE_APP_API4_DOMAIN === 'http://localhost:3000' || process.env.VUE_APP_API4_DOMAIN == "https://dev-api4.ballotpedia.org") ? 'import-engine-service-profile-page-creation-task-test' : 'import-engine-service-profile-page-creation-task',
          launch_type: 'FARGATE'   
        }
        params.containerOverrides = container_overrides;
        
        let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'}; 
        headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/run_tasks/run_ecs_task`;

        let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
          method: "POST",
          headers: headers,
          credentials: 'include',
          body: JSON.stringify(params)
        });

        response = await response.json();  
        
        if(response.success === true ) {
            alert('The Page Creation process has been started. ');
        } else {
          alert('There was an issue starting the Page Creation process.  Please try again or contact a member of the tech team.')
        }
        //} catch(e) {
          //console.log(e)
        //} 
      } else {
        alert('No pages have been selected.')
      }
    },


    async promoteToGold(allOrSome) {
      try {
        let ids ='';
        let dataObject = {}
        if (allOrSome == 'selected') {
          this.$refs.hot.$refs.hot.hotInstance.getSourceData().forEach(item => {
            if (item.promoteselected === true && item.id) {
              ids = ids + `${item.id},`;
            }
          });
          ids = ids.slice(0, -1)
        } else if (allOrSome == 'all') {
          //to do - query the view to get all of the ids where batch = batch and contest_status = 'Can be Promoted'
          ids = 'all'
        }
        if (ids == '') {
           alert('No contests have been selected.');
           return;
        }
        dataObject['contests'] = `{ ${ids} }`
        dataObject['named_bfed_batch'] = parseInt(this.batch_id)
        dataObject['status'] = 1
        let payload = {
          data: [dataObject],
          table: 'ultralocal.promote_to_gold_log'
        };
        //update promote to gold log
        let headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
        };
        headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/insertOne`;

        let response = await fetch(
          `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
          {
            method: "POST",
            headers: headers,
            credentials: "include",
            body: JSON.stringify(payload),
          }
        );
        
        response = await response.json();
        if (response.success === false) {  
          console.log('could not update process log')
        }
        
        const container_overrides = {
          "name": 'import-engine-service-gold-upload' ,
          "environment": [
            {
              "name": "contests",
              "value": ids
            },
            {
              "name": "PTG_ID",
                "value": response.data['id']
            },
            {
              "name": "batch",
                "value": this.batch_id
            }
              ]
        }
            
        let params = {
          cluster_name: 'default',
          task_definition: (process.env.VUE_APP_API4_DOMAIN === 'http://localhost:3000' || process.env.VUE_APP_API4_DOMAIN == "https://dev-api4.ballotpedia.org") ? 'import-engine-service-upload-to-gold-task-test' : 'import-engine-service-upload-to-gold-task',
          launch_type: 'FARGATE'
        }
        params.containerOverrides = container_overrides;
             
        headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/run_tasks/run_ecs_task`;

        response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
          method: "POST",
          headers: headers,
          credentials: 'include',
          body: JSON.stringify(params)
        });

        response = await response.json();  
        
        if(response.success === true ) {
           alert('The Promote to Gold process has been started. ');
        } else {
          alert('There was an issue starting the Promote to Gold process.  Please try again or contact a member of the tech team.')
        }
      } catch(e) {
        //console.log(e)
      }
      this.refreshHoTData();
    },


    async submitDeletes() {
      if (confirm("Are you sure you want to delete the selected record(s)?")) {
        let ids = new Array();
        this.$refs.hot.$refs.hot.hotInstance.getSourceData().forEach(item => {
          if (item.columnselected === true && item.id) {
            ids.push(item.id);
          }
        });
        if (ids.length > 0) {
          let response = await this.deleteRecords(this.table, ids);

          if ( response.status == 403 ) {
            response = await response.json();
            alert(response.message);
            window.location.href = '/login';
          }
          else {
            if (response.ok === true) {
              alert("Record(s) deleted.");
            } else {
              response = await response.json();
              response = JSON.parse(response.message)

              alert(`There was a problem. Records were not deleted. ${response.message}`);
            }
            this.refreshHoTData();
          }
        } else {
          alert("Records must have an ID to be deleted");
        }
      }
    },

    
    async refreshHoTData() {
      let table = this.$route.params.table;
      let id = this.$route.query.id;
      this.hotdata = [];
      if (window.location.href.indexOf("where") > -1) {
        this.loading = true;
        let query = JSON.parse(
          JSON.stringify(decodeURIComponent(window.location.href ? window.location.href.split("?")[1] : window.location.search.slice(1)))
        );
        this.query = JSON.parse(query).where;
        this.limit = JSON.parse(query).limit;
        this.offset = JSON.parse(query).offset;
        this.workflow = JSON.parse(query).workflow;
        const orderBy = JSON.parse(query).orderBy;
        if (orderBy) {
          const orderByParts = orderBy.match(/^(.*)\s+(asc|desc)$/i);
          this.orderBy = orderByParts ? orderByParts[1] : orderBy;
          this.sortDirection = orderByParts ? orderByParts[2].toLowerCase() : '';
        }

        this.showSearch = true;
        await this.getFilteredData();
        this.setWorkflow();
        this.loading = false;
      } else if (id) {
        // If ID query param exists, GET that single entry
        this.loading = true;

        let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
        headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud?table=${table}&ids=${id}`;

        fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
          // TODO: Refactor to use async / await
          method: "GET",
          headers: headers,
          credentials: 'include'
        })
          .then(response => {
            return response.json();
          })
          .then(response => {
            response.data.forEach(item => {
              item["columnselected"] = false;
              item["promoteselected"] = false;
              this.hotdata.push(item);
            });
            this.loading = false;
          });
      } else {
        // Else populate table with most recent updated records for table
        await this.getFilteredData();
      }
    },

    // local candidate research worksheet: assign candidates to researchers when they view the table
    async makeResearchWorksheetAssignments() {
      const roles = localStorage.getItem('roles');
      
      // only make assignments for this worksheet; and if user has certain roles and isn't QA
      if ( !((this.table === 'local_candidate_research_worksheet') && (roles.includes('local_candidate_researcher') || roles.includes('volunteer_local_candidate_researcher')) && (!roles.includes('qa_volunteer_local_candidate_researcher')))
         && !((this.table === 'local_candidate_campaign_themes_research_worksheet') && roles.includes('local_campaign_themes_researcher')))
      {
        return;
      }

      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        resource: `${process.env.VUE_APP_API4_DOMAIN}/research_worksheets/assignments`
      };
    
      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
        method: 'POST',
        headers: headers,
        credentials: 'include',
        body: JSON.stringify({"table":this.table})
      });
      response = await response.json();

      if (response.success) {
        this.assignmentError = false;
      } else {
        this.assignmentError = true;
      }
    },
  },

  data() {
    return {
      hotdata: [],
      columnMetaData: [],
      columnWidths: [],
      leftColsFixed: 0,
      hiddenColumns: [],
      workflowOptions: [],
      workflow: '',
      table: this.$route.params.table,
      loading: false,
      showSearch: false,
      query: null,
      limit: 25,
      offset: 1,
      orderBy: null,
      orderByFilters: [],
      sortDirection: '',
      rules: [],
      labels: {
        matchType: "Match Type",
        matchTypes: [{ id: "all", label: "All of the filters" }, { id: "any", label: "Any of the filters" }],
        addRule: "Add Filter"
      },
      depth: 1,
      isCountOnly: false,
      countReturned: false,
      picked: null,
      permissions: this.getTablePermissions(this.$route.params.table),
      visibility: "display:inline",
      toggleEditHistory: false,
      activeQuery: false,
      searchError: false,
      assignmentError: false,
      columnsMoved: false,
      batch_id: null,
      domain: null
    };
  },
  beforeMount: async function() {
    this.canAdd = this.permissions.includes('INSERT');
    this.canDelete = this.permissions.includes('DELETE');
    this.canUpdate = this.permissions.includes('UPDATE');
  },
  mounted: async function() {

    if (window.location.href.indexOf("bfed_batch_id") > -1) {
       this.batch_id  = JSON.parse(
          JSON.stringify(decodeURIComponent(window.location.href ? window.location.href.split("?")[1] : window.location.search.slice(1)))
        );
          this.batch_id = this.batch_id.replace('bfed_batch_id=', '');
    } 
    process.env.VUE_APP_API4_DOMAIN == "https://api4.ballotpedia.org" ? this.domain = 'prod' : this.domain = 'test';
    this.rules = await this.generateFiltersForSearch();
    this.orderByFilters = await this.getOrderByFilters(this.rules);
    await this.generateColumnMetaData('Edit', this.table);
    this.workflowOptions = await this.getHotWorkflows(this.table, 'edit');
    await this.makeResearchWorksheetAssignments();
    this.hideColumns();
    await this.refreshHoTData();
  },
 
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-select,
.record-number {
  width: 75px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
}

.orderBy,
.sortBy {
  width: 120px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
}

.frozenSelect {
  width: 70px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
}

.workflow {
  width: 160px;
}

.search-options label {
  font-size: 12px;
}

.search-options .form-control {
  height: 30px;
}

.btn {
  margin-top: 30px;
  margin-bottom: 20px;
}

.btn-default {
  margin-right: 10px;
}

.btn-hide {
  margin-right: 0px;
  margin-bottom: 10px;
  margin-top: 0px;
}

.btn-share,
.btn-search {
  margin-bottom: 2px;
  width: 125px;
}

.checkbox {
  margin-top: 0px;
}

h3 {
  margin-bottom: 20px;
}
label {
  padding-top: 5px;
}

.table-name {
  text-align: left;
}
.container-fluid {
  margin-right: 3%;
  margin-left: 5%;
}
.show-search {
  margin-top: 0;
  margin-bottom: 0;
}
.badge-error {
  background-color: red;
  color: white;
}
.edit-add {
  color: #337ab7;
}
</style>
